var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAnimadoX2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e8NPb91vf6I1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1113 945",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-1494.993652)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.47417 0 0 1.60714 2435.33-907.679)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 755,
    height: 588,
    rx: 0,
    ry: 0,
    transform: "translate(-1652 1495)",
    clipRule: "evenodd",
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.617374 0 0 1.617374 983.2313-924.845031)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e8NPb91vf6I6",
    opacity: 0,
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.571463 0 0 0.31396-1616.51 1579.13)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386,152L583,349L386,546L189,349L386,152Z",
    clipRule: "evenodd",
    fill: "#091d4b",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.571463 0 0 0.31396-1729.09 1640.98)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386,152L583,349L473.464,458.536l-197-197L386,152Z",
    clipRule: "evenodd",
    fill: "#dfdfdf",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.571463 0 0 0.31396-1204.91 1595.52)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.25,296.812L583,349L386,546l-51.75-52.188l197-197Z",
    clipRule: "evenodd",
    fill: "#c4c4c4",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.571463 0 0 0.31396-1553.91 1544.74)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386,152L583,349L473.464,458.536l-197-197L386,152Z",
    clipRule: "evenodd",
    fill: "#dfdfdf",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.571463 0 0 0.31396-1064.09 1517.28)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.25,296.812L583,349L386,546l-51.75-52.188l197-197Z",
    clipRule: "evenodd",
    fill: "#c4c4c4",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.571463 0 0 0.31396-1729.09 1517.28)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.464,239.464L583,349L386,546L276.464,436.464l197-197Z",
    clipRule: "evenodd",
    fill: "#dfdfdf",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.571463 0 0 0.31396-1729.09 1517.28)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.25,296.812L583,349L386,546l-51.75-52.188l197-197Z",
    clipRule: "evenodd",
    fill: "#c4c4c4",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.571463 0 0 0.31396-1553.91 1613.52)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.464,239.464L583,349L386,546L276.464,436.464l197-197Z",
    clipRule: "evenodd",
    fill: "#dfdfdf",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.571463 0 0 0.31396-1586.94 1595.52)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.25,296.812L583,349L386,546l-51.75-52.188l197-197Z",
    clipRule: "evenodd",
    fill: "#c4c4c4",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "e8NPb91vf6I29_ts",
    transform: "translate(-1395.928492,1750.55216) scale(0.040089,0.040089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e8NPb91vf6I29",
    transform: "translate(1395.928492,-1750.55216)",
    opacity: 0,
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.678347 0 0 0.622222-1652 564.778)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.5,1905.71L473.551,1848v-173.7h-192.102v173.7l96.051,57.71Z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.881487 0 0 0.604818-3137.3 885.088)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 7,
    rx: 0,
    ry: 0,
    transform: "translate(1927 1240)",
    clipRule: "evenodd",
    fill: "#091d4b",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.881487 0 0 0.604818-3137.3 898.013)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 7,
    rx: 0,
    ry: 0,
    transform: "translate(1927 1240)",
    clipRule: "evenodd",
    fill: "#091d4b",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.881487 0 0 0.604818-3137.3 938.731)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 7,
    rx: 0,
    ry: 0,
    transform: "translate(1927 1240)",
    clipRule: "evenodd",
    fill: "#091d4b",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.881487 0 0 0.604818-3137.3 910.492)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 7,
    rx: 0,
    ry: 0,
    transform: "translate(1927 1240)",
    clipRule: "evenodd",
    fill: "#091d4b",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.881487 0 0 0.604818-3137.3 951.209)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 7,
    rx: 0,
    ry: 0,
    transform: "translate(1927 1240)",
    clipRule: "evenodd",
    fill: "#091d4b",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "e8NPb91vf6I42_to",
    transform: "translate(-1395.637512,1610.467095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e8NPb91vf6I42_ts",
    transform: "scale(0.144347,0.144347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e8NPb91vf6I42",
    transform: "translate(1395.637512,-1581.694519)",
    opacity: 0,
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.314628 0.086058-.096716 0.297506-1908.74 1072.34)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1867,1141l50,50",
    clipRule: "evenodd",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#e2706c",
    strokeWidth: 30.52,
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.288505 0.143743 0.161547 0.272805-1008.52 991.998)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1867,1141l50,50",
    clipRule: "evenodd",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7ccc96",
    strokeWidth: 30.52,
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.521311 0 0 0.261915-2421.75 1272.08)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1969,1191v-50",
    clipRule: "evenodd",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#e8b54d",
    strokeWidth: 24.21,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAnimadoX2);
export default __webpack_public_path__ + "static/media/logo-animado-x2.b48238db2e3958ddba763b5edf3c7258.svg";
export { ForwardRef as ReactComponent };